import { getValueFromPath } from './utils';

/**
 * Check if a feature is enabled for a feature key
 * @requires MA.Config
 * @return {boolean}
 */
export function checkDispatcher(key, type = 'ab') {
    return Boolean(getValueFromPath(global, `MA.Config.DISPATCHERS.${type}_dispatcher.${key}`));
}
